module.exports = __webpack_public_path__ + "static/media/killickaerospace.2019a8e0.jpg";